import { useState } from "react";
import { useLoaderData, useSearchParams } from "react-router";

import { loader as storeLocatorLoader } from "./loader.server";

import { useContentfulLiveUpdates } from "@contentful/live-preview/react";

import { ContentBanner } from "~/contentful/components/content-banner";

import LeftSideContent from "./left-side-content";
import RightSideContent from "./right-side-content";

export const loader = storeLocatorLoader;

const StoreLocator = () => {
  const { shops, content, total, brandLogo, customerStore } =
    useLoaderData<typeof loader>();
  const liveContent = useContentfulLiveUpdates(content);
  const liveBrandLogo = useContentfulLiveUpdates(brandLogo);
  const [searchParams] = useSearchParams();
  const preview = !!searchParams.get("preview");
  const bottomContent = preview ? liveContent : content;
  const brandLogoContent = preview ? liveBrandLogo : brandLogo;
  const defaultLocation = { lat: 37.7749, lng: -122.4194 };
  const [mapCenter, setMapCenter] = useState(defaultLocation);
  const [mapZoom, setMapZoom] = useState(13);
  const [hoveredStoreId, setHoveredStoreId] = useState<string | null>(null);

  return (
    <>
      <div className="flex w-full flex-col md:mt-10 md:flex-row">
        <LeftSideContent
          mapCenter={mapCenter}
          mapZoom={mapZoom}
          shops={shops}
          hoveredStoreId={hoveredStoreId}
          setHoveredStoreId={setHoveredStoreId}
        />
        <RightSideContent
          shops={shops}
          mapCenter={mapCenter}
          setMapCenter={setMapCenter}
          total={total}
          brandLogo={brandLogoContent}
          setHoveredStoreId={setHoveredStoreId}
          customerStore={customerStore}
        />
      </div>
      <ContentBanner content={bottomContent} className="mt-20 h-72" />
    </>
  );
};

export default StoreLocator;
